import { css } from 'styled-components';
import { BoxPropsMapping } from './props.js';
import { getCssProperties, generateBoxPropStyles } from './utils.js';

/**
 * Maps given props to CSS styles according to given Box prop mappings.
 * Duplicated, uses web imports
 */
var propsMappingToStyles = function propsMappingToStyles(mappings) {
  return function (props) {
    return css(["", ""], Object.keys(props).filter(function (propName) {
      return mappings[propName];
    }).map(function (propName) {
      var cssProperties = getCssProperties(mappings[propName]);
      var propValue = props[propName];
      if (propValue === undefined) return;
      return cssProperties.map(function (cssProperty) {
        return generateBoxPropStyles(cssProperty, propValue);
      }).join('\n');
    }));
  };
};
var boxStyles = /*#__PURE__*/css(["", ""], propsMappingToStyles(BoxPropsMapping));

export { boxStyles, propsMappingToStyles };
